import React, { Component } from 'react'
import PropTypes from 'prop-types'

import CSSModules from 'react-css-modules'
import FontIcon from 'react-toolbox/lib/font_icon'
import { Flex, Box } from 'reflexbox'

import styles from './styles.scss'

const TimelineMiddleSubSection = (props) => {
  return (
    <Flex column align='center' justify='flex-start'>
      { props.children }
    </Flex>
  )
}

TimelineMiddleSubSection.propTypes = {
}

export default CSSModules(TimelineMiddleSubSection, styles)
